import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react'

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'ghost'
  | 'text'

export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg'

export type ButtonPreviewState =
  | 'default'
  | 'hover'
  | 'pressed'
  | 'focused'
  | 'disabled'
  | 'loading'

export const BUTTON_VARIANTS: ButtonVariant[] = [
  'primary',
  'secondary',
  'tertiary',
  'ghost',
  'text',
]

export const BUTTON_SIZES: ButtonSize[] = ['xs', 'sm', 'md', 'lg']

export const BUTTON_SIZE_LABELS: Record<ButtonSize, string> = {
  xs: 'XS',
  sm: 'S',
  md: 'M',
  lg: 'L',
}

export const BUTTON_PREVIEW_STATES: ButtonPreviewState[] = [
  'default',
  'hover',
  'pressed',
  'focused',
  'disabled',
  'loading',
]

export const BUTTON_PREVIEW_STATE_LABELS: Record<ButtonPreviewState, string> = {
  default: 'Default',
  hover: 'Hover',
  pressed: 'Pressed',
  focused: 'Focused',
  disabled: 'Disabled',
  loading: 'Loading',
}

export type ButtonProps = {
  children?: ReactNode
  label?: string
  variant?: ButtonVariant
  size?: ButtonSize
  destructive?: boolean
  /** @deprecated Prefer `darkMode`. */
  dark?: boolean
  /** Dark theme. */
  darkMode?: boolean
  loading?: boolean
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  fullWidth?: boolean
  className?: string
  style?: CSSProperties
  /** Static visual state for the design-system showcase only. */
  previewState?: ButtonPreviewState
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>

export type ButtonShowcaseVariantGroup = {
  id: string
  label: string
  variant: ButtonVariant
  destructive?: boolean
}

export const BUTTON_SHOWCASE_VARIANT_GROUPS: ButtonShowcaseVariantGroup[] = [
  { id: 'primary', label: 'Primary', variant: 'primary' },
  {
    id: 'primary-destructive',
    label: 'Primary destructive',
    variant: 'primary',
    destructive: true,
  },
  { id: 'secondary', label: 'Secondary', variant: 'secondary' },
  {
    id: 'secondary-destructive',
    label: 'Secondary destructive',
    variant: 'secondary',
    destructive: true,
  },
  { id: 'tertiary', label: 'Tertiary', variant: 'tertiary' },
  { id: 'ghost', label: 'Ghost', variant: 'ghost' },
  { id: 'text', label: 'Text', variant: 'text' },
]
